import { consumer, core } from '@tock/coretypes';
import { displayInDollars } from '@tock/money';
import { logger } from '@tock/logging';
import _ from 'lodash';

const shouldSendRestaurantPixel =
  typeof window !== 'undefined'
    ? window.location.hostname.indexOf('staging.exploretock.com') < 0
    : false;

export const fbPurchase = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fbqTrack: (...args: any[]) => void,
  purchaseOrder: core.PurchaseOrder,
  business: consumer.BusinessConfig
) => {
  fbqTrack(
    'trackSingle',
    'Purchase',
    {
      content_type: 'Tock Purchase',
      content_name: purchaseOrder.ticketTypeName,
      value: displayInDollars(purchaseOrder.totalPrice),
      num_items: purchaseOrder.ticketCount,
      currency: business.currencyCode,
    },
    { eventID: `purchase-${purchaseOrder.id}` }
  );

  fbqTrack(
    'trackSingle',
    'Schedule',
    {
      content_type: 'Tock Purchase',
      content_name: purchaseOrder.ticketTypeName,
      value: displayInDollars(purchaseOrder.totalPrice),
      num_items: purchaseOrder.ticketCount,
      currency: business.currencyCode,
    },
    { eventID: `schedule-${purchaseOrder.id}` }
  );
};

export const fbqAddScript = (
  facebookPixelId?: string | null,
  businessFacebookPixelId?: string | null
) => {
  if (window.fbq) {
    return;
  }

  if (facebookPixelId || businessFacebookPixelId) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) {
        return;
      }
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-spread, prefer-rest-params
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) {
        f._fbq = n;
      }
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fbqWrapperDefault = (...args: any[]) => {
  logger.debug('Analytics.fbqWrapper', ...args);
};

// IMPORTANT - getFbqWrapper must return a function - we must attempt to access the window.fbq function when called
export const getFbqWrapper = () => {
  if (!window.fbq) {
    return fbqWrapperDefault;
  } else {
    return window.fbq;
  }
};

export const addFbqTrackToWindow = (
  fastRoutingBetweenContext: boolean,
  facebookPixelId: string,
  businessFacebookPixelId: string | null | undefined,
  businessFacebookBusinessPixelId: string | null | undefined
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fbqTrack = (...allArgs: any[]) => {
    const args = new Array(allArgs.length + 1);
    for (let i = 0; i < allArgs.length; i++) {
      if (i === 0) {
        args[0] = allArgs[0];
        args[1] = facebookPixelId + ''; // FUCKING HELL, Facebook sdk cannot handle pixel that is a number;
      } else {
        args[i + 1] = allArgs[i];
      }
    }

    getFbqWrapper()(...args);
    if (!fastRoutingBetweenContext && businessFacebookPixelId && shouldSendRestaurantPixel) {
      const businessArgs = _.cloneDeep(args);
      businessArgs[1] = businessFacebookPixelId;
      getFbqWrapper()(...businessArgs);
    }

    if (
      !fastRoutingBetweenContext &&
      shouldSendRestaurantPixel &&
      businessFacebookBusinessPixelId &&
      businessFacebookPixelId !== businessFacebookBusinessPixelId &&
      ['Schedule', 'PageView'].includes(allArgs[1])
    ) {
      const businessArgs = _.cloneDeep(args);
      businessArgs[1] = businessFacebookBusinessPixelId;
      getFbqWrapper()(...businessArgs);
    }
  };

  window.analytics.fbqTrack = fbqTrack;

  return fbqTrack;
};

export const fbqSetupTracking = (facebookPixelId?: string | null): void => {
  getFbqWrapper().disablePushState = true;
  facebookPixelId && getFbqWrapper()('init', facebookPixelId);
};

export const fbqSetupBusinessTracking = (
  businessFacebookPixelId?: string | null,
  businessFacebookBusinessPixelId?: string | null,
  fastRoutingBetweenContext?: boolean
): void => {
  if (businessFacebookBusinessPixelId) {
    getFbqWrapper()('init', businessFacebookBusinessPixelId);
  }

  if (businessFacebookPixelId && !fastRoutingBetweenContext) {
    getFbqWrapper()('init', businessFacebookPixelId);
  }
};
